<modal>
  <span header>{{service.ID > 0 ? ('Chỉnh sửa' | lang) + ' ' + service.Name : ('Tạo dịch vụ mới' | lang)}}</span>
  <p>{{'Tên' | lang}}</p>
  <input type="text" [(ngModel)]="service.Name" />
  <p>{{'Địa chỉ' | lang}}</p>
  <input type="text" [(ngModel)]="service.Address" />
  <p>{{'Nhóm' | lang}}</p>
  <select [(ngModel)]="service.GroupID">
    <option [ngValue]="0">{{'Chọn nhóm' | lang}}</option>
    <option *ngFor="let i of groups" [ngValue]="i.ID">{{i.Name}}</option>
  </select>
  <div class="flex">
    <button class="text-white bg-success" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
